import { Link } from 'react-router-dom';
import { Col, Result, Row } from 'antd';

import { Links } from 'links';

export const Page404 = () => {
  const link = <Link to={Links.Snaps}>Go To Snaps</Link>;

  return (
    <Row className='h-full' align='middle'>
      <Col xs={24}>
        <Result
          title='404'
          status='404'
          extra={link}
          subTitle='Sorry, the page you visited does not exist.'
        />
      </Col>
    </Row>
  );
};
